import { AxiosInstance } from 'axios';
import { AgencyPerfermanceOverviewReportRequestModel } from './models/AgencyPerfermanceOverviewReportPage';
import * as AccountsReceivableSalesJournalReportService from './services';

export type AgencyPerfermanceOverviewReportServiceType = {
  exportPDF: (payload: AgencyPerfermanceOverviewReportRequestModel) => Promise<void>;
};

export const initAgencyPerfermanceOverviewReportService = (
  axios: AxiosInstance
): AgencyPerfermanceOverviewReportServiceType => ({
  exportPDF: payload => AccountsReceivableSalesJournalReportService.exportPDF(axios)(payload),
});
